import React from 'react';

import i18n from '@client/utils/i18n';
import { LightChannelDoc, SpectrogramPoint } from '@ledium/types';
import { If, ItemList, ListComponentProps } from '@ledium/ui-common';

import LightChannelList from './Components/LightChannelList';

type LightChannelItem = LightChannelDoc & {
    id: string;
    group?: { name: string };
};

const LightChannelsMainMenu = () => {
    function isLocked(lightChannel: LightChannelItem) {
        if (lightChannel.locked?.reason) {
            if (lightChannel.locked.reason === 'RUNNING_PROJECT') {
                return i18n('light_channel_running_project', lightChannel.locked.projectName) as string;
            }
        }
        return false as const;
    }

    function isLinked(lightChannel: LightChannelItem) {
        if (lightChannel.linked?.reason === 'LINKED_PROJECT_AND_SPECTRUM_MIX') {
            return i18n('light_channel_linked_project', lightChannel.linked.spectrumMixName, lightChannel.linked.projectName) as string;
        }
        return false as const;
    }

    function additionalItemListInfo(channel: LightChannelItem) {
        return (
            <>
                <span>
                    {i18n('light_channel_details', <b>{channel.channel}</b>, <b>{channel.resolution}</b>)}, <b>{channel.spectrogramRanges?.pfd?.sum}</b>{' '}
                    {i18n('pfd_unit')}
                </span>
                <If condition={!!channel.group?.name}>
                    <>
                        <br />
                        <span>{i18n('light_channel_group', <b>{channel.group?.name}</b>)}</span>
                    </>
                </If>
            </>
        );
    }

    function chart(item: LightChannelItem): SpectrogramPoint[] {
        return item.spectrogram;
    }

    return (
        <ItemList<LightChannelItem>
            chart={chart}
            isLocked={isLocked}
            isLinked={isLinked}
            allowDuplicate={true}
            additionalItemListInfo={additionalItemListInfo}
            ListComponent={LightChannelList as unknown as React.ComponentType<ListComponentProps<LightChannelItem>>}
        />
    );
};

export default LightChannelsMainMenu;
